import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

const LoadingSpinner: React.FC = () => (
  <Grid
    container
    display="flex"
    position="relative"
    alignItems="center"
    justifyContent="center"
    width="100%"
    height="100vh"
  >
    <CircularProgress />
  </Grid>
);

interface LoaderProps {
  isLoading: boolean;
  children: React.ReactNode;
}

export const Loader: React.FC<LoaderProps> = ({ isLoading, children }) => {
  if (isLoading) {
    return <LoadingSpinner />;
  }

  return children;
};

export const CircularIndeterminate: React.FC = () => <LoadingSpinner />;
